import * as i0 from '@angular/core';
import { Injectable, Optional, Inject, NgModule } from '@angular/core';
import * as i1 from '@egovsolutions/angular-artificial-navigations';
import * as i2 from '@angular/material/dialog';

const DEBUG_DIALOG_NAVIGATIONS = 'debug-dialog-navigation-injection-token';
class DialogNavigations {
    constructor(
    // Dependencies
    artificialNavigations, matDialog, 
    // Passed values
    debugDialogNavigations) {
        // Bindings
        this.artificialNavigations = artificialNavigations;
        this.matDialog = matDialog;
        this.debugDialogNavigations = debugDialogNavigations;
        // Navigation handling
        this.restore$ = this.artificialNavigations.restore$;
        this.dialogClosedHandler = this.dialogClosedHandler.bind(this);
        this.close = this.close.bind(this);
        // Initialize
        this.init();
    }
    // Initialization
    init() {
        this.initializeDialogClosureHandling();
        this.initializeNavigationHandling();
    }
    // Set
    set(dialogRef, optionsOrDefinitionOrType) {
        // Log
        if (this.debugDialogNavigations)
            console.log('set', dialogRef, optionsOrDefinitionOrType); // tslint:disable-line
        // Normalize options
        const options = this.artificialNavigations.turnDefinitionOrTypeIntoOptions(optionsOrDefinitionOrType) || {};
        // Set id
        options.id = dialogRef.id;
        // Set onDropped callback if not present
        if (!options.onDropped)
            options.onDropped = () => this.close(dialogRef);
        // Set artificial navigation
        this.artificialNavigations.set(options);
    }
    // Close
    close(dialogRef) {
        if (this.debugDialogNavigations)
            console.log('close', dialogRef, dialogRef.componentInstance); // tslint:disable-line
        if (dialogRef.componentInstance && 'closeAttempt' in dialogRef.componentInstance)
            dialogRef.componentInstance.closeAttempt();
        else
            dialogRef.close();
    }
    fulfill(dialogId, andChildDialogs = false) {
        this.artificialNavigations.fulfill(dialogId, andChildDialogs);
    }
    // Dialog closure handling
    initializeDialogClosureHandling() {
        this.matDialog.afterOpened
            .subscribe(dialogRef => dialogRef.afterClosed().subscribe(() => this.dialogClosedHandler(dialogRef)));
    }
    dialogClosedHandler(dialogRef) {
        if (this.debugDialogNavigations)
            console.log('dialogClosedHandler', dialogRef.id, dialogRef.componentInstance); // tslint:disable-line
        this.artificialNavigations.reportDropped(dialogRef.id);
    }
    initializeNavigationHandling() {
        this.artificialNavigations.navigationHandled$
            .subscribe(handledNavigation => this.closeUntrackedDialogs(handledNavigation));
    }
    closeUntrackedDialogs(handledNavigation) {
        if (this.debugDialogNavigations)
            console.log('closeUntrackedDialogs'); // tslint:disable-line
        this.matDialog.openDialogs
            .filter(dialogRef => handledNavigation.restored.indexOf(dialogRef.id) === -1)
            .filter(dialogRef => handledNavigation.kept.indexOf(dialogRef.id) === -1)
            .filter(dialogRef => handledNavigation.dropped.indexOf(dialogRef.id) === -1)
            .forEach(this.close);
    }
}
DialogNavigations.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogNavigations, deps: [{ token: i1.ArtificialNavigations }, { token: i2.MatDialog }, { token: DEBUG_DIALOG_NAVIGATIONS, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
DialogNavigations.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogNavigations });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogNavigations, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.ArtificialNavigations }, { type: i2.MatDialog }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DEBUG_DIALOG_NAVIGATIONS]
                }] }]; } });

class DialogNavigationsModule {
}
DialogNavigationsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogNavigationsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DialogNavigationsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogNavigationsModule });
DialogNavigationsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogNavigationsModule, providers: [DialogNavigations] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogNavigationsModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [DialogNavigations]
                }]
        }] });

/*
 * Public API Surface of angular-dialog-navigations
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DEBUG_DIALOG_NAVIGATIONS, DialogNavigations, DialogNavigationsModule };
